var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { DotLoader } from "syf-component-library/ui/atoms";
import { Grid } from "syf-component-library/ui/patterns";
import { Stack } from "syf-component-library/ui/spacing";
import { useQueryClient } from "@tanstack/react-query";
import { accountSummaryV2CacheKey } from "@syf-api-library/account-summary";
import { PAGE_NAME } from "../../../const/analytics";
import { useAccountSummary, useCreditHealthPutMutation, } from "../../../const/syfApiQueries";
import { useVantageContext } from "../../../context/vantageContext";
import triggerVantageAnalytics from "../../../helpers/triggerVantageAnalytics";
import { useConfig } from "../../../hooks/useConfig";
import VantageLayout from "../../../layout";
import VantageTrans from "../../atoms/VantageTrans";
import Benefit from "./Benefit";
import CreditScoreBenefits from "./helpers";
import { AgreementText, BenefitsWrapper, EnrollButton, NoCreditBodyWrapper, NoCreditScoreBodySubTitle, } from "./subcomponents";
var NoCreditScorePage = function (_a) {
    var accountToEnroll = _a.accountToEnroll;
    var config = useConfig();
    var queryClient = useQueryClient();
    var dispatch = useVantageContext().dispatch;
    var assets = config.hosts.assets;
    var isLoadingAccountSummary = useAccountSummary(accountToEnroll).isLoading;
    var _b = useCreditHealthPutMutation({
        config: config,
    }), mutateAsync = _b.mutateAsync, isEnrolling = _b.isLoading;
    var isLoading = isEnrolling || isLoadingAccountSummary;
    var handleEnrollment = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, mutateAsync({
                            "cipher.accountId": accountToEnroll,
                            accountIdType: "guid",
                            enrolled: true,
                        })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    dispatch({ shouldShowErrorPage: true });
                    return [3 /*break*/, 3];
                case 3: return [4 /*yield*/, queryClient.resetQueries({
                        queryKey: accountSummaryV2CacheKey({
                            accountId: accountToEnroll,
                            accountIdType: "guid",
                        }),
                        exact: true,
                    })];
                case 4:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        return triggerVantageAnalytics({
            pageSubFunction: "enroll",
            pageName: PAGE_NAME.VANTAGE_START,
        });
    }, []);
    return (_jsx(VantageLayout, __assign({ headeri18nKey: "noCreditScorePage.headerSection.getYouCreditScoreToday" }, { children: _jsxs(NoCreditBodyWrapper, { children: [_jsx(Stack, { size: "large" }), _jsx(NoCreditScoreBodySubTitle, __assign({ as: "h2", weight: "bold" }, { children: _jsx(VantageTrans, { i18nKey: "noCreditScorePage.bodySection.subtitle" }) })), _jsx(Stack, { size: "large", hideOnBreakpointUp: "medium" }), _jsx(Stack, { size: "xlarge", hideOnBreakpointDown: "small" }), _jsx(Stack, { size: "medium", hideOnBreakpointDown: "small" }), _jsx(BenefitsWrapper, __assign({ "data-testid": "benefits-container" }, { children: _jsx(Grid, __assign({ mobileGap: { rowGap: 15, columnGap: 15 }, tabletGap: { rowGap: 19, columnGap: 21 } }, { children: CreditScoreBenefits.map(function (_a) {
                            var imageUrl = _a.imageUrl, transKey = _a.transKey, id = _a.id;
                            return (_jsx(Grid, __assign({ item: true, xs: 12, md: 6 }, { children: _jsx(Benefit, __assign({ imageUrl: "".concat(assets, "/assets/vantage/").concat(imageUrl) }, { children: _jsx(VantageTrans, { i18nKey: transKey }) })) }), id));
                        }) })) })), _jsx(Stack, { size: "xlarge" }), _jsx(EnrollButton, __assign({ buttonType: "primary", onClick: handleEnrollment, disabled: isLoading, type: "button", "data-type": "credit score", "data-analytics": "clicktrackingevent", "data-reason": "enroll me now" }, { children: isLoading ? (_jsx(DotLoader, {})) : (_jsx(VantageTrans, { i18nKey: "noCreditScorePage.bodySection.enrollMeButton" })) })), _jsx(Stack, { size: "xlarge" }), _jsx(AgreementText, { children: _jsx(VantageTrans, { i18nKey: "noCreditScorePage.bodySection.agreement" }) }), _jsx(Stack, { size: "xxlarge" }), _jsx(Stack, { size: "xxlarge", hideOnBreakpointDown: "small" })] }) })));
};
export default NoCreditScorePage;
